<template>
	<div>
		<div
			class="flex min-h-[2.75rem]"
		>
			<ShoppingListMenuCta />
			<button
				type="button"
				class="btn rounded-none !pl-3 pr-4 rounded-r-full hover:z-10 -ml-px"
				:class="userIsLogged ? 'btn-secondary' : 'btn-secondary'"
				@click="handleUserMenuClick"
			>
				<NuxtIcon
					name="user"
					filled
					class="text-[1.25rem]"
					:class="userIsLogged ? 'text-icon-primary' : 'text-body-primary'"
				/>
				<span class="max-sm:hidden">
					<span v-if="userIsLogged" class="flex items-center gap-2">
						{{ profile?.personalInfo?.name }}
						{{ profile?.personalInfo?.surname }}

						<NuxtIcon
							name="chevron-down"
							filled
							class="text-base text-icon-primary"
							:class="userIsLogged ? '' : ''"
						/>
					</span>
					<span v-else class="flex flex-col leading-tight text-left pr-4 text-body-secondary">
						<span class="text-xs font-semibold">Můj Globus</span>
						<span class="text-[.625rem] font-normal">Přihlásit se</span>
					</span>
				</span>
			</button>
		</div>

		<ClientTeleport>
			<HeaderNavSecondary v-model:model="vModelData" />
		</ClientTeleport>
	</div>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useCustomerProfileStore} from '~/stores/customerProfile';
	import type {Header} from '~/types/header';
	import {UserState} from '~/stores/crmStateStore';

	type Props = {
		model: Header
	};

	const props = defineProps<Props>();

	const vModelData = useVModel(props, 'model');

	const customerProfileStore = useCustomerProfileStore();
	const {userIsLogged, profile} = storeToRefs(customerProfileStore);

	const {redirectToCrm} = useCrmRedirect();

	function handleUserMenuClick() {
		if (!userIsLogged.value) {
			redirectToCrm(UserState.USER_MENU_ANONYMOUS_SLIDEOUT_LOGIN);
			trackHeaderEvent('muj_globus_bonus_top');
		} else {
			vModelData.value.visibleUserMenu = !vModelData.value.visibleUserMenu;
			trackHeaderEvent('user_name_top', `${profile.value?.personalInfo?.name} ${profile.value?.personalInfo?.surname}`);
		}
	}
</script>
